import { SET_DELETECATEGORY } from '../actions';

const deletecategory = (state = [], action) => {
  switch (action.type) {
	case SET_DELETECATEGORY:
      return [...action.value];  
    default: return state;
  }
}

export default deletecategory;
